import gql from "graphql-tag";

import { fragmentOrderDetails } from "./orders";

export const shipmentFragment = gql`
  ${fragmentOrderDetails}
  fragment shipmentFragment on shipmentCenter_type {
    id
    shipmentCompany
    orderNumber
    trackingNumber
    trackingCode
    totalWeight
    shipedDate
    shipedDelivered
    shippingDetails
    shipmentInfo
    courierCode
    sku
    orders {
      ...OrderDetailsFragment
    }
  }
`;
